import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=1fd96b5d&scoped=true"
import script from "./GlobalLoading.vue?vue&type=script&lang=ts"
export * from "./GlobalLoading.vue?vue&type=script&lang=ts"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&id=1fd96b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd96b5d",
  null
  
)

export default component.exports